export default "__VITE_ASSET__3613378f__"